module.exports = __webpack_public_path__ + "static/media/snake-3.6630d05a.jpg";